// Navigation Icons - Re-export existing styled-icons
import React from "react";
import {
  AngleDownIcon,
  AngleRightIcon,
  AngleLeftIcon,
  SearchIcon,
  BellIcon as BellIconStyled,
  MenuAlt1Icon,
  TreesIcon,
  LineGraphIcon,
  MapIcon as MapIconStyled,
  TaskIcon,
  DashboardIcon,
  GridIcon,
  FileExportIcon,
  SensorsIcon,
  CloseOutlineIcon,
  ProjectIcon,
  AddIcon,
  QuestionMarkIcon,
  InfoIcon,
} from "@components/icons";

// Simple re-export with consistent naming
export const ChevronDown = AngleDownIcon;
export const ChevronRight = AngleRightIcon;
export const ChevronLeft = AngleLeftIcon;
export const Search = SearchIcon;
export const MenuIcon = MenuAlt1Icon;
export const X = CloseOutlineIcon;
export const Folder = ProjectIcon;
export const Star = InfoIcon;
export const Building2 = GridIcon;
export const Plus = AddIcon;
export const TreePine = TreesIcon;
export const BarChart3 = DashboardIcon;
export const Activity = SensorsIcon;
export const CheckSquare = TaskIcon;
export const FileText = FileExportIcon;
export const MapIcon = MapIconStyled;
export const BellIcon = BellIconStyled;
export const HelpCircle = QuestionMarkIcon;
export const PanelLeft = MenuAlt1Icon;
export const PanelLeftClose = CloseOutlineIcon;
export const LineGraph = LineGraphIcon;
